import React, { useEffect, useState } from 'react';
import { auth } from '../firebase';
import '../styles/PrivateFlyerViewer.css';

const VALID_ASSET_ID = /^[a-f0-9]{64}$/;

function PrivateFlyerViewer({ assetId = '' }) {
  const [state, setState] = useState({ status: 'loading', objectUrl: null });

  useEffect(() => {
    let disposed = false;
    let objectUrl = null;
    const controller = new AbortController();
    setState({ status: 'loading', objectUrl: null });

    async function load() {
      if (!VALID_ASSET_ID.test(assetId)) {
        setState({ status: 'error', message: 'This flyer link is invalid.', objectUrl: null });
        return;
      }
      const user = auth.currentUser;
      if (!user) {
        setState({ status: 'error', message: 'Sign in to open this private flyer.', objectUrl: null });
        return;
      }

      try {
        const token = await user.getIdToken();
        if (disposed) return;
        const response = await fetch(`/api/private-flyers/${assetId}`, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
          cache: 'no-store',
          signal: controller.signal
        });
        if (!response.ok) {
          throw new Error(response.status === 404 ? 'This flyer is no longer available.' : 'This flyer could not be opened.');
        }
        const contentType = String(response.headers.get('content-type') || '').toLowerCase();
        if (!contentType.startsWith('application/pdf')) {
          throw new Error('The private flyer response was not a PDF.');
        }
        const blob = await response.blob();
        if (disposed) return;
        objectUrl = URL.createObjectURL(blob);
        setState({ status: 'ready', objectUrl });
      } catch (error) {
        if (disposed || error?.name === 'AbortError') return;
        setState({
          status: 'error',
          message: error?.message || 'This flyer could not be opened.',
          objectUrl: null
        });
      }
    }

    load();
    return () => {
      disposed = true;
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [assetId]);

  if (state.status === 'error') {
    return <main className="private-flyer-viewer"><p role="alert">{state.message}</p></main>;
  }
  if (state.status !== 'ready') {
    return <main className="private-flyer-viewer"><p role="status">Opening private flyer…</p></main>;
  }
  return (
    <main className="private-flyer-viewer">
      <iframe title="Private broker flyer" src={state.objectUrl} />
    </main>
  );
}

export default PrivateFlyerViewer;
